import { useQuery } from 'react-query';

import { getTopCriticalPathAdded as queryFn } from 'api/endPoints/getTopCriticalPathAdded';

export const useQueryCriticalPathAddedTableData = (params) => {
    return useQuery(['criticalPathAddedTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
